// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2udtw","black":"button_black__MxWvU","white":"button_white__1T9AV"};